import  DatePicker  from 'element-ui/lib/date-picker';
import  elButton  from 'element-ui/lib/button';
import 'element-ui/lib/theme-chalk/date-picker.css';
import 'element-ui/lib/theme-chalk/button.css';
import 'element-ui/lib/theme-chalk/icon.css';
import seckillDetail from "./seckillDetail/seckillDetail.vue";

import { Component , Vue , Watch ,Prop} from "vue-property-decorator";
Vue.component('el-date-picker',DatePicker)
Vue.component('el-butten',elButton)
@Component({
	components: { seckillDetail }
})
export default class seckillModal extends Vue {
    @Prop() private roomData!: any;
    params:any={
        roomId:'',
        sceneId:'',
        id:'',
        pageNum:1,
        pageSize:30,
        createStartTime: '',
        createEndTime: '',
        activityName: '',
        startTime: '',
        endTime: '',
        auditStatus: '-1' //活动状态  -1 查询所有 1-待审核 2-审核通过 3-待开始 4-进行中 5-已结束 10-删除
    }
    auditStatus:object= {
        '1':'待审核',
        '2':'审核通过',
        '3':'待开始',
        '4':'进行中',
        '5':'已结束',
        '10':'已删除',
    }
    activityTimes:any=''
    createTimes:any=''
    seckillItem:any={//当前秒杀数据

    }
    activityData:any=[]
    isSeckillManage:boolean = true // 弹窗boolean
    isSeckillDetail:boolean = false //是否显示详情
    detailType:string = 'create'//显示详情的状态
	api:any={
        seckillActivityApi: "https://opc" + this.domain +"/ule-live-amdin/api/v1/room/seckillActivity/saveSeckillActivity",//创建、修改、删除活动
        seckillListApi: "https://opc" + this.domain +"/ule-live-amdin/api/v1/room/seckillActivity/list?",
        pushGoodsApi: "https://opc" + this.domain +"/ule-live-amdin/api/v1/room/seckillActivity/addSeckillGoods"
	}
    @Watch('isSeckillManage') 
	onChange(val:any,oldVal:any){
        if(!val){
            this.$emit('hintChange' , {name:'isSeckillManage',val:val})
        }
	}
	mounted() {
        
        console.log(this.roomData);
        this.params.roomId = this.$route.params.id
        this.params.sceneId = this.roomData.scene_id
		this.getSeckillListData(true)
	}

	getSeckillListData(init:boolean){//获取秒杀活动列表
        let url = this.api.seckillListApi
        // let seckillStatus:any = this.$refs.seckillStatus
        // this.params.auditStatus = seckillStatus.value
        if (this.activityTimes) {
            this.params.startTime = this.activityTimes[0]
            this.params.endTime = this.activityTimes[1]
        }else{
            this.params.startTime = ''
            this.params.endTime = ''
        }
        if (this.createTimes) {
            this.params.createStartTime = this.createTimes[0]
            this.params.createEndTime = this.createTimes[1]
        }else{
            this.params.createStartTime = ''
            this.params.createEndTime = ''
        }
        for (const key in this.params) {
            if (Object.prototype.hasOwnProperty.call(this.params, key)) {
                const par = this.params[key];
                url += `&${key}=${par}`
            }
        }
		this.fetch({
			url: url,
			method: "get",
		}).then((res:any) => {
            if (init && (!res.data || res.data.length == 0)) {
                this.isSeckillDetail = true
            }
            this.activityData = res.data
            console.log(this.activityData);
            
		})	
	}
    closeDetail(query:boolean){//关闭创建活动页面
        this.isSeckillDetail = false
        if (query) {
            this.getSeckillListData(false)
        }
    }
    deleteActivity(act:any){//删除活动
        this.fetch({
            url: this.api.seckillActivityApi,
            data:{id:act.id,auditStatus:'10'},
            method: "post",
            // headers: {
            //     'Content-Type': 'application/json'
            // },
            noQS:true,
            formJson:true
        }).then((res:any) => {
            this.$toast("删除成功")
            this.getSeckillListData(false)
        }).catch((err:any)=>{
            this.$toast(err.msg)
        })	
    }
    pushGoodsApi(act:any){//推送活动商品
        let url = `${this.api.pushGoodsApi}?id=${act.id}&roomId=${this.$route.params.id}&sceneId=${this.roomData.scene_id}`
        this.fetch({
            url: url,
            method: "get",
        }).then((res:any) => {
            this.$toast("推送成功")
        }).catch((err:any)=>{
            this.$toast(err.msg)
        })	
    }
    changeActivity(type:string,act:any){//创建/查看/修改活动
        this.seckillItem = act?act:''
        this.detailType = type
        this.isSeckillDetail = true
    }
    search(){
        this.params.pageNum = 1
        this.getSeckillListData(false)
    }
}
